import React from 'react';
import EvaluationForm from './EvaluationForm';

const FreeEvaluation: React.FC = () => {
  return (
    <div className="bg-white min-h-screen text-left flex flex-col items-center py-10 px-4 pt-24">
      <div className="max-w-7xl w-full px-4 md:px-10">
        <h1 className="text-4xl font-extrabold text-[#0097b2] mb-6">Free Evaluation</h1>
        <p className="text-[21px] text-gray-700 mb-4">Please complete the evaluation form below. Our attorneys will review your submission and respond within 24 business hours.</p>
        <div className="mt-6">
          <EvaluationForm />
        </div>
      </div>
    </div>
  );
};

export default FreeEvaluation;
